import { Component, OnInit, HostListener } from '@angular/core';
import {IClient} from '../../../shared/interfaces/IClient';
import {Store} from '@ngrx/store';
import {AppState} from '../../../app.reducer';
import {SessionService} from '../../../core/services/session.service';
import {RouterLinkActive, Router} from '@angular/router';
import { ScrollService } from '../../../core/services/scroll.service';

@Component({
  selector: 'app-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss']
})
export class LandingHeaderComponent implements OnInit {
  scrollPosition: number = 0;
  menuState = false;
  user: IClient;
  userMenuOpen = false;
  
  constructor(private store: Store<AppState>, private sessionService: SessionService, private router: Router, private scrollService: ScrollService) { }

  ngOnInit(): void {
    this.store.select('core').subscribe(res => {
      this.user = res.user;
    });
    this.scrollService.getScrollPosition().subscribe((event: any) => {
      this.scrollPosition = window.scrollY;
      // this.scrollPosition contiene la posición actual del scroll
    });
  }

  closeMenu() {
    this.menuState = false;
  }

  toggleUserMenu(): void {
    this.userMenuOpen = !this.userMenuOpen;
  }
  
  @HostListener('document:click', ['$event'])
  closeUserMenuOnClickOutside(event: MouseEvent) {
    // Comprobar si el clic fue fuera del menú de usuario
    const userMenuButton = document.querySelector('.user-menu-button');
    const userMenu = document.querySelector('.user-menu');
    
    if (userMenuButton && !userMenuButton.contains(event.target as Node) && 
        userMenu && !userMenu.contains(event.target as Node)) {
      this.userMenuOpen = false;
    }

    // Cerrar menú mobile si el click es fuera del botón hamburguesa y del drawer
    const mobileButton = document.querySelector('.mobile-menu-button');
    const mobileMenu = document.querySelector('.mobile-menu');
    if (this.menuState && mobileButton && mobileMenu) {
      const target = event.target as Node;
      const clickedOutside = !mobileButton.contains(target) && !mobileMenu.contains(target);
      if (clickedOutside) {
        this.closeMenu();
      }
    }
  }

  logout(): void {
    this.userMenuOpen = false; // Cerrar el menú al hacer logout
    this.sessionService.removeToken().then(_ => {
      this.user = null;
      // Recargar la página para limpiar todos los datos en memoria
      window.location.reload();
    });
  }
}
